import classNames from 'classnames'
import { TProduct } from 'feature/appeals/type'
import { memo } from 'react'
import { ModalCloseButton } from 'widget/ModalCloseButton/ModalCloseButton'

import { EditProductParamsForm } from '../EditProductParamsForm/EditProductParamsForm'

import style from './ModalEditProductParams.module.scss'

type TModalEditProductParams = {
  product: TProduct
  onClose: () => void
}

// модальное окно для формы редактирования параметров

export const ModalEditProductParams = memo(
  ({ onClose, product }: TModalEditProductParams) => {
    const { name, parameters, blankedParameters } = product

    if (parameters.length > 0 || blankedParameters.length > 0) {
      return (
        <div className={style.modalEditProductParams}>
          <span className={classNames('h2', style.title)}>{name}</span>
          <ModalCloseButton onClose={onClose} />
          <EditProductParamsForm
            parameters={parameters}
            blankedParameters={blankedParameters}
            product={product}
            onClose={onClose}
          />
        </div>
      )
    }
    return <>Ошибка загрузки данных</>
  },
)
